import { BaseModel, fillOwnProperties, registerModel } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'

export default class UnifiedProfilePublishing extends BaseModel {
  static override constructorName = 'UnifiedProfilePublishingModel'

  'publishing_status': string = ''
  'publishing_status_at': string = ''
  'publishing_refuse_reason': string = ''
  'publishing_refuse_reason_description': string = ''

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data)
    }
  }
}

registerModel(UnifiedProfilePublishing)
